import { gsap } from "gsap";

export const initAccordions = () => {
	if (!document.querySelector(".accordion-item")) return;

	const accordions = document.querySelectorAll(".accordion-item");

	accordions.forEach((accordion) => {
		const header = accordion.querySelector(".accordion-header");
		const content = accordion.querySelector(".accordion-content");

		header.addEventListener("click", () => {
			const isOpen = accordion.classList.contains("open");
			console.log("Accordion clicked. Is open:", isOpen);

			if (isOpen) {
				gsap.to(content, {
					height: 0,
					duration: 0.1,
					ease: "power1.inOut",
					onComplete: () => {
						accordion.classList.remove("open");
						content.style.height = "";
					},
				});
			} else {
				accordion.classList.add("open");
				gsap.fromTo(
					content,
					{ height: 0 },
					{
						height: "auto",
						duration: 0.2,
						ease: "power1.inOut",
						onComplete: () => {
							// content.style.height = "";
						},
					},
				);
			}
		});
	});
};
